import React from 'react';
import { RotateCcwIcon, UsersIcon } from 'lucide-react';
import { toast } from 'sonner';
import { useStore } from '../../contexts/StoreContext';
interface RoleOption {
  id: string;
  label: string;
  name: string;
}
interface DemoSidePanelProps {
  title: string;
  roles: RoleOption[];
  active: string | null;
  onChange: (id: string) => void;
  hints: string[];
}
export function DemoSidePanel({
  title,
  roles,
  active,
  onChange,
  hints
}: DemoSidePanelProps) {
  const {
    resetDemo
  } = useStore();
  return <div className="space-y-3" data-id="element-459" data-mp="32uwjkqnsfzd6">
      <div className="card p-4" data-id="element-460" data-mp="32vz5ek697bm8">
        <div className="flex items-center gap-2 text-navy" data-id="element-461" data-mp="2o5s07659bp3h">
          <UsersIcon className="h-4 w-4" data-id="element-462" data-mp="2o7bbsjfyxbyx" />
          <h2 className="text-sm font-bold" data-id="element-463" data-mp="2t4lc4u4wb81j">ডেমো রোল সুইচার</h2>
        </div>
        <p className="mt-0.5 text-xs text-ink-muted" data-id="element-464" data-mp="2t2icrjhus2k5">{title}</p>
        <div className="mt-3 space-y-1.5" data-id="element-465" data-mp="2f6d7e01mb2ft">
          {roles.map(r => <button key={r.id} onClick={() => onChange(r.id)} className={`w-full rounded-lg border px-3 py-2 text-left transition-colors duration-150 ${active === r.id ? 'border-navy bg-navy text-white' : 'border-line bg-white hover:bg-navy-50'}`} data-id="element-466" data-mp="2j6x452ia441f">
              <p className="text-sm font-semibold" data-id="element-467" data-mp="38jmt57c9ds55">{r.label}</p>
              <p className={`text-xs ${active === r.id ? 'text-white/75' : 'text-ink-muted'}`} data-id="element-468" data-mp="33ka8mt8v0x5q">{r.name}</p>
            </button>)}
        </div>
      </div>
      <div className="card p-4" data-id="element-469" data-mp="2fv7lx6zdce4d">
        <h3 className="text-sm font-bold text-ink" data-id="element-470" data-mp="2avmkmpwq7toh">উপস্থাপনার নির্দেশনা</h3>
        <ul className="mt-2 space-y-1.5 text-xs text-ink-muted list-disc pl-4" data-id="element-471" data-mp="2ati5fbtdn88w">
          {hints.map(h => <li key={h} data-id="element-472" data-mp="2pmloxoqj3w29">{h}</li>)}
        </ul>
      </div>
      <button className="btn btn-ghost btn-sm" onClick={() => {
      resetDemo();
      toast.success('ডেমো তথ্য রিসেট করা হয়েছে।');
    }} data-id="element-473" data-mp="2ktiqb26w9wf7">
        <RotateCcwIcon className="h-3.5 w-3.5" data-id="element-474" data-mp="1x2n6ar8ok5ii" /> ডেমো রিসেট
      </button>
    </div>;
}